import RestAPI from '../../../components/Common/restApi';

export default class QuickbooksOnlineErrorsApi {
  static index({ page, pageSize, filters, sortBy, sortDirection }) {
    return RestAPI.getWithQueryString('/alpha/quickbooks_online/errors', {
      page,
      page_size: pageSize,
      filters,
      sort_by: sortBy,
      sort_direction: sortDirection,
    });
  }

  static repair(errorId, repairParams = {}) {
    return RestAPI.postWithFormData(`/alpha/quickbooks_online/errors/${errorId}/repair`, { options: repairParams });
  }

  static rerun(errorId) {
    return RestAPI.postWithFormData(`/alpha/quickbooks_online/errors/${errorId}/rerun`);
  }

  static dismiss(errorId) {
    return RestAPI.delete(`/alpha/quickbooks_online/errors/${errorId}`);
  }

  static bulkDismiss(errorIds) {
    return RestAPI.postWithFormData('/alpha/quickbooks_online/errors/bulk_dismiss', { ids: errorIds });
  }
}
